var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Resolver } from "did-resolver";
import { getResolver as ethrGetResolver } from "ethr-did-resolver";
import { getResolver as webGetResolver } from "web-did-resolver";
import NodeCache from "node-cache";
import { INFURA_API_KEY } from "../config";
import { generateProvider } from "../common/utils";
export const getProviderConfig = () => {
    var _a, _b, _c;
    const provider = generateProvider();
    const rpcUrl = ((_a = provider === null || provider === void 0 ? void 0 : provider.connection) === null || _a === void 0 ? void 0 : _a.url) || "";
    const networkName = ((_b = provider === null || provider === void 0 ? void 0 : provider._network) === null || _b === void 0 ? void 0 : _b.name) === "homestead" ? "mainnet" : ((_c = provider === null || provider === void 0 ? void 0 : provider._network) === null || _c === void 0 ? void 0 : _c.name) || "";
    if (!rpcUrl || !networkName) {
        return { networks: [{ name: "mainnet", rpcUrl: `https://mainnet.infura.io/v3/${INFURA_API_KEY}` }] };
    }
    return {
        networks: [{ name: networkName, rpcUrl: rpcUrl }],
    };
};
const didResolutionCache = new NodeCache({ stdTTL: 5 * 60 }); // 5 min
const defaultResolver = new Resolver(Object.assign(Object.assign({}, ethrGetResolver(getProviderConfig())), webGetResolver()));
export const createResolver = ({ ethrResolverConfig }) => {
    const resolverRegistry = Object.assign(Object.assign({}, ethrGetResolver(ethrResolverConfig !== null && ethrResolverConfig !== void 0 ? ethrResolverConfig : {})), webGetResolver());
    return ethrResolverConfig ? new Resolver(resolverRegistry) : defaultResolver;
};
export const resolve = (didUrl, resolver) => __awaiter(void 0, void 0, void 0, function* () {
    const cachedResult = didResolutionCache.get(didUrl);
    if (cachedResult)
        return cachedResult;
    const didResolutionResult = resolver ? yield resolver.resolve(didUrl) : yield defaultResolver.resolve(didUrl);
    const did = didResolutionResult.didDocument || undefined;
    didResolutionCache.set(didUrl, did);
    return did;
});
export const getVerificationMethod = (did, key, resolver) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const didDocument = yield resolve(did, resolver);
    if (!didDocument)
        return;
    return (_a = didDocument.verificationMethod) === null || _a === void 0 ? void 0 : _a.find((k) => k.id.toLowerCase() === key.toLowerCase());
});
